import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { ComponentBaseService } from './component-base.service'
import { ServicesConstants } from '../services-constants'
import { ParametriServizio } from '../_models/parametri-servizio';
import { Utils } from '../utils';
import { delayedRetry } from './delayed-retry';

@Injectable()
export class ParametriServizioService extends ComponentBaseService {

  constructor(
    private http: HttpClient
  ) {
    super();
  }

  getServiceName(): string {
    return "ParametriServizioService";
  }

  /** GET ParametriServizio by id. Will 404 if id not found */
  getElencoParametriServizi(): Observable<ParametriServizio[]> {
    let url = `${ServicesConstants.URL_PARAMETRISERVIZI}`;

    return this.http.get<ParametriServizio[]>(url).pipe(
      delayedRetry(),
      tap(_ => this.log(`fetched Elenco Parametri`)),
      catchError(this.handleError<ParametriServizio[]>(`getElencoParametriServizi`))
    );
  }

  /** GET ParametriServizio by id. Will 404 if id not found */
  getParametriServizio(tipoProdotto: string): Observable<ParametriServizio> {
    const url = `${ServicesConstants.URL_PARAMETRISERVIZI}/${tipoProdotto}`;
    return this.http.get<ParametriServizio>(url).pipe(
      delayedRetry(),
      tap(_ => this.log(`fetched ParametriServizio nomeParametriServizio=${tipoProdotto}`)),
      catchError(this.handleError<ParametriServizio>(`getParametriServizio id=${tipoProdotto}`))
    );
  }

  //////// Save methods //////////

  /** PUT: update the ParametriServizio on the server */
  updateParametriServizio(parametriServizio: ParametriServizio): Observable<any> {
    const url = `${ServicesConstants.URL_PARAMETRISERVIZI}/${parametriServizio.tipoProdotto}`;

    return this.http.put(url, parametriServizio, this.httpOptions).pipe(
      tap(_ => this.log(`updated ParametriServizio id=${parametriServizio.tipoProdotto}`)),
      catchError(this.handleError<any>('updateParametriServizio'))
    );
  }

}


// WEBPACK FOOTER //
// ./src/app/_services/parametri-servizio.service.ts